import { AnnualReportModel } from '@app/core/Models';
import { Guid } from 'guid-typescript';
export class SaveAnnualReport {
  static readonly type = '[AnnualReport] Save Annual Report';

  constructor(public annualReportData: AnnualReportModel) {}
}
export class ConvertToHtml {
  static readonly type = '[AnnualReport] Convert To Html';

  constructor(public sfdt: any) {}
}
export class ConvertToHtmlToSfdt {
  static readonly type = '[AnnualReport] Convert Html to Sfdt';

  constructor(public html: any) {}
}
export class ExportAsPdf {
  static readonly type = '[AnnualReport] Export As PDF';

  constructor(public saveDocumentToPdfParameter: any) {}
}

export class GetByAccountPeriod {
  static readonly type = '[AnnualReport] Get By Account Period';

  constructor(public accountPeriodId: Guid) {}
}

export class GetListSavedFile {
  static readonly type = '[AnnualReport] Get List  SavedFile';

  constructor(public accountPeriodId: Guid) {}
}

export class ExportAnnualReport {
  static readonly type = '[AnnualReport] Export Annual Report';

  constructor(public accountPeriodId: Guid) {}
}

export class GetTrusteesReport {
  static readonly type = '[AnnualReport] Get Trustees Report';

  constructor(public accountPeriodId: Guid) {}
}

export class GetIndependentExaminerReport {
  static readonly type = '[AnnualReport] Get Independent Examiner Report';

  constructor(public accountPeriodId: Guid) {}
}

export class GetAnnualReportContent {
  static readonly type = '[AnnualReport] Get Annual Report Content';

  constructor(public accountPeriodId: Guid) {}
}

export class GetAccountingMethod {
  static readonly type = '[AnnualReport] Get Accounting Method';
}

export class GetAnnualReportResponse {
  static readonly type = '[AnnualReport] Get Annual Report Response';

  constructor(public accountPeriodId: Guid) {}
}

export class GetSavedAnnualReportResponse {
  static readonly type = '[AnnualReport] Get Save Annual Report Response';

  constructor(public accountPeriodId: Guid, public Id: any) {}
}

export class SaveAnnualReportResponse {
  static readonly type = '[AnnualReport] Save Annual Report Response';

  constructor(public param: any, public accountPeriodId: Guid) {}
}

export class UploadAnnualReportResponse {
  static readonly type = '[AnnualReport] Upload Annual Report Response';

  constructor(public file: any) {}
}

export class DeleteSavedFile {
  static readonly type = '[AnnualReport] Delete Saved File';

  constructor(public Ids: Array<Guid>, public accountPeriodId: Guid) {}
}

export class DownloadSavedAnnualReport {
  static readonly type = '[AnnualReport] Donwload Save Annual Report';

  constructor(public accountPeriodId: Guid, public Id: any, public docType : string) {}
}

export class DownloadAnnualReport {
  static readonly type = '[AnnualReport] Donwload Annual Report';

  constructor(public annualReportDownload: any) {}
}
export class GetContactList {
  static readonly type = '[AnnualReport] Get Contact List';

  constructor(public contactTypeid: any) {}
}

export class GetAdditionalNotesAndPolicies {
  static readonly type = '[AdditionalDisclosures] Get Additional Notes and Policies';

  constructor(public type: string) {}
}

export class GetAdditionalAccountingPolicy {
  static readonly type = '[AdditionalDisclosures] Get Additional Accounting Policy';

  constructor(public notes: any) {}
}

export class CreateAdditionalNotesAndPolicy {
  static readonly type = '[AdditionalDisclosures] Create Additional Notes And Policy';

  constructor(public notes: any,public type:string) {}
}
export class UpdateAdditionalNotesAndPolicyStatus {
  static readonly type = '[AdditionalDisclosures] Update Additional Notes And Policy Status';

  constructor(public notes: [],public isactive:boolean,public type:string) {}
}

export class RegenerateAnnualReport {
  static readonly type = '[AnnualReport] Regenerate Annual Report';

  constructor(public accountPeriodId: Guid, public Id: any) {}
}

export class TrusteeReportPreviewInHtml{
  static readonly type = '[TrusteesReport] Preview In Html';

  constructor(public accountPeriodId: Guid) {}
}
export class DeleteAdditionalNotesandPolicies {
  static readonly type = '[AdditionalDisclosures] Delete Additional Notes and Policies';

  constructor(public ids: [], public type: string) {}
}